import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import React from 'react';

import Description from './description';
import * as ST from './styled';

const PopupContent = ({ title, price, onConnectTariff, onCancel, isLoading }) => {
    return (
        <ST.PopupContainer>
            <ST.PopupHeader>{'Подключение услуги «Смотри везде»'}</ST.PopupHeader>

            <Description
                title={title}
                price={price}
            />

            <ST.Paragraph>
                Приятного просмотра!
            </ST.Paragraph>

            <ST.PopupButtonsWrapper>
                <ST.Button
                    width={ST.POPUP_BUTTON_WIDTH}
                    onClick={onConnectTariff}
                    disabled={isLoading}
                    type={btnTypes.ACCENT}
                >
                    Подключить
                </ST.Button>

                <ST.Button
                    width={ST.POPUP_BUTTON_WIDTH}
                    onClick={onCancel}
                    type={btnTypes.SECONDARY}
                >
                    Выбрать другой тариф
                </ST.Button>
            </ST.PopupButtonsWrapper>
        </ST.PopupContainer>
    );
};

export default PopupContent;
